import React from 'react'
import { Typography } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'

export default () => {
  return (
    <Typography className="text-red-600 text-14">
      <FormattedMessage id="translation.message.error" />
    </Typography>
  )
}
